import React from 'react';
import Radio from '../../forms/Radio';
import Row from '../../layout/Row';
import Input from '../../forms/Input';
import { QuestRoute } from '../../api/QuestRoutes';
import Checkbox from '../../forms/Checkbox';
import Preput from '../../forms/Preput';
import FormSetting from '../../layout/FormSetting';
import { Regex } from '../../utility/regex';
import PageBreak from '../../layout/PageBreak';
import HamQuest from '../../api/HamQuestGiver';
import Modal from '../../Modal';
import GetState from '../../GetState';
import Loading from '../../Loading';
import ModalFactory from '../../Modal';
import Col from '../../layout/Col';
import PhoneNumberInput from '../../forms/formComponents/PhoneNumberInput';
import { formatPhone } from '../../utility/functions';

export const customInput = (days, hours, mins, setValues, maxDays = 120) => {

    let totalTime = (days * 24 * 60) + (hours * 60) + mins * 1;

    if (totalTime > (maxDays * 24 * 60)) {
        totalTime = (maxDays * 24 * 60)
    }
    if (totalTime === 0) {
        totalTime = 1
    }

    const totalHours = Math.floor(totalTime / 60);
    const remainingMinutes = totalTime % 60;
    const totalDays = Math.floor(totalHours / 24);
    const remainingHours = totalHours % 24;

    setValues(v => {
        return {
            ...v,
            'expirationDays': totalDays,
            'expirationHours': remainingHours,
            'expirationMinutes': remainingMinutes,
        }
    })
}

const SingleUseCodes = ({ ...props }) => {

    const [SUCSettings, refreshSettings] = GetState(QuestRoute.codes.singleUseSettings);

    if (!SUCSettings) return <Loading page />;

    return (
        <PageBreak>
            <FormSetting
                controls={[
                    <Input
                        label='Daily Bulk Code Limit'
                        value={`${SUCSettings.bulkUsesRemaining} Remaining of ${SUCSettings.bulkCodeLimit}`}
                        standalone
                        readOnly
                    />,
                    <Input
                        label='Daily Single Code Limit'
                        value={`${SUCSettings.singleUsesRemaining} Remaining of ${SUCSettings.singleCodeLimit}`}
                        standalone
                        readOnly
                    />
                ]}
                inputs={{
                    item: '',
                    expirationDays: SUCSettings.expirationDays ?? 100,
                    expirationHours: SUCSettings.expirationHours ?? 0,
                    expirationMinutes: SUCSettings.expirationMinutes ?? 0,
                    quantity: 1,
                    sendCode: true,
                    emailAddress: '',
                    phoneNumber: '',
                    addMessage: 'false',
                    message: '',
                    generatePDF: true,
                }}
                onSubmit={e => {
                    const config = {};
                    if (e.generatePDF) {
                        config.download = true;
                    }
                    return HamQuest.post(QuestRoute.codes.singleUse, { ...e, }, config)
                        .then(res => {
                            refreshSettings();
                            if (e.generatePDF) {
                                const blobUrl = URL.createObjectURL(res.file);
                                const link = document.createElement('a');
                                link.href = blobUrl;
                                link.download = res.metaData.filename || `SingleUseCodes.pdf`;

                                document.body.appendChild(link);
                                link.click();

                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(blobUrl);
                            } else {
                                if (e.sendCode) {
                                    ModalFactory.show({
                                        title: 'Code Created',
                                        body: `The code has been ${e.emailAddress && e.phoneNumber
                                            ? `texted to ${formatPhone(e.phoneNumber)} and emailed to ${e.emailAddress}`
                                            : e.emailAddress
                                                ? `emailed to ${e.emailAddress}`
                                                : `texted to ${formatPhone(e.phoneNumber)}`}`
                                    })
                                } else {
                                    ModalFactory.show({
                                        title: 'Code(s) Created',
                                        body: (
                                            <Col>
                                                {res.map(code => <span>{code.replace(/(\d{3}\B)/g, '$1-')}</span>)}
                                            </Col>
                                        )
                                    })
                                }
                            }
                        })
                        .catch(ModalFactory.catch)

                }}
                text='Create Code'
            >
                {({ values, setValues, setValue, setFormError }) =>
                    <>
                        <Radio
                            label='Item (SKU)'
                            name='item'
                            getOptions={QuestRoute.kiosks.wash}
                            buildOptions={(e) => {
                                e.label = `${e.name} (${e.sku})`;
                                e.value = e.id
                            }}
                            required
                        />

                        <span>Expiration Time (Max {SUCSettings.maxDays} days)</span>
                        <Row>
                            <Input
                                label='Days'
                                name='expirationDays'
                                type='number'
                                min={0}
                                max={SUCSettings.maxDays}
                                onInput={(e) => customInput(e.target.value, values.expirationHours, values.expirationMinutes, setValues, SUCSettings.maxDays)}
                                required
                            />
                            <Input
                                label='Hours'
                                name='expirationHours'
                                type='number'
                                min={0}
                                max={2880}
                                onInput={(e) => customInput(values.expirationDays, e.target.value, values.expirationMinutes, setValues, SUCSettings.maxDays)}
                                required
                            />
                            <Input
                                label='Minutes'
                                name='expirationMinutes'
                                type='number'
                                min={0}
                                max={172800}
                                onInput={(e) => customInput(values.expirationDays, values.expirationHours, e.target.value, setValues, SUCSettings.maxDays)}
                                required
                            />
                        </Row>
                        <Input
                            label={'Quantity' + (values.phoneNumber ? ' (Max 1 code when sending as a text)' : '')}
                            name='quantity'
                            type='number'
                            min={1}
                            max={values.phoneNumber ? 1 : 500}
                            required
                            readOnly={values.phoneNumber}
                        />

                        <Row wrap align='flex-end'>
                            <Checkbox
                                label='Send Customer Code'
                                name='sendCode'
                            />

                            <Input
                                label='Email Address'
                                name='emailAddress'
                                validate={Regex.test.email}
                                disable={values.sendCode === false}
                                required={values.sendCode === true && !values.phoneNumber}
                            />
                            <PhoneNumberInput
                                disable={values.sendCode === false}
                                required={values.sendCode === true && !values.emailAddress}
                                callback={() => setValue('quantity', 1)}
                            />
                        </Row>

                        <Checkbox
                            label='Download as PDF'
                            name='generatePDF'
                        />

                        <Radio
                            label={'Add Message'}
                            name='addMessage'
                            options={[
                                {
                                    label: 'None',
                                    value: 'false'
                                }, {
                                    label: 'Default Message',
                                    value: 'defaultMessage'
                                }, {
                                    label: 'Custom Message',
                                    value: 'customMessage'
                                },
                            ]}
                            required
                            disable={values.phoneNumber}
                            callback={e => setValue('message', e === 'defaultMessage' ? SUCSettings.defaultSingleUseCodeMsg : '')}
                        />

                        <Preput
                            label='Message'
                            name='message'
                            disable={values.addMessage !== 'customMessage' || values.phoneNumber}
                        />
                    </>

                }
            </FormSetting>
        </PageBreak>
    );

}

export default SingleUseCodes;